import type { ReactNode } from "react";
import { toast } from "sonner";
import ic_close from "@/assets/images/ic_close.png";
import ic_error from "@/assets/images/ic_error.png";
import ic_success from "@/assets/images/ic_success.png";
import ic_warning from "@/assets/images/ic_warning.png";

function makeid(length: number) {
  let result = "";
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

function Content(props: {
  icon: React.ReactNode;
  children: ReactNode;
  id: string;
}) {
  return (
    <div className="border border-[rgb(33,34,37)] rounded-2xl bg-[#0A0A0C] px-4 py-3 flex flex-row gap-2.5 items-center justify-between">
      <div className="flex flex-row gap-2 items-center justify-start">
        {props.icon}
        <div className="text-base text-[#EEEEF0] font-medium text-pretty">
          {props.children}
        </div>
      </div>
      <button
        onClick={() => {
          toast.dismiss(props.id);
        }}
        className="w-5 h-5 flex-none"
        type="button"
      >
        <img src={ic_close} className="w-5 h-5" alt="close" />
      </button>
    </div>
  );
}

export const toaster = {
  success: (message: string | ReactNode) => {
    const id = makeid(5);
    toast.custom(
      () => (
        <Content
          id={id}
          icon={<img className="w-8 h-8" src={ic_success} alt="success" />}
        >
          {message}
        </Content>
      ),
      {
        id,
        duration: 5000,
      }
    );
  },
  error: (message: string | ReactNode) => {
    const id = makeid(5);
    toast.custom(
      () => (
        <Content
          id={id}
          icon={<img className="w-8 h-8" src={ic_error} alt="error" />}
        >
          {message}
        </Content>
      ),
      {
        id,
        duration: 5000,
      }
    );
  },
  warning: (message: string | ReactNode) => {
    const id = makeid(5);
    toast.custom(
      () => (
        <Content
          id={id}
          icon={<img className="w-8 h-8" src={ic_warning} alt="warning" />}
        >
          {message}
        </Content>
      ),
      {
        id,
        duration: 5000,
      }
    );
  },
};
